/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Btn_Trial_And_MonthlyInputs */

const en_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try 7 days, ${i?.price}/month`)
};

const ar_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const de_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const es_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const fr_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const it_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const ja_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const ko_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const ru_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const th_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const tr_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_btn_trial_and_monthly = /** @type {(inputs: Btn_Trial_And_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`試用 7 天，訂閱 ${i?.price}/月`)
};

/**
* | output |
* | --- |
* | "Try 7 days, {price}/month" |
*
* @param {Btn_Trial_And_MonthlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_trial_and_monthly = /** @type {((inputs: Btn_Trial_And_MonthlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Trial_And_MonthlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_trial_and_monthly(inputs)
	if (locale === "ar") return ar_btn_trial_and_monthly(inputs)
	if (locale === "de") return de_btn_trial_and_monthly(inputs)
	if (locale === "es") return es_btn_trial_and_monthly(inputs)
	if (locale === "fr") return fr_btn_trial_and_monthly(inputs)
	if (locale === "it") return it_btn_trial_and_monthly(inputs)
	if (locale === "ja") return ja_btn_trial_and_monthly(inputs)
	if (locale === "ko") return ko_btn_trial_and_monthly(inputs)
	if (locale === "pt_br") return pt_br_btn_trial_and_monthly(inputs)
	if (locale === "ru") return ru_btn_trial_and_monthly(inputs)
	if (locale === "th") return th_btn_trial_and_monthly(inputs)
	if (locale === "tr") return tr_btn_trial_and_monthly(inputs)
	if (locale === "zh_cn") return zh_cn_btn_trial_and_monthly(inputs)
	return zh_tw_btn_trial_and_monthly(inputs)
});